import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { LogoutSuccess } from 'cpie-common';
import { fetchLogoutSuccess } from './LogoutSuccessSlice';
import { LogoutSuccessContentSelector } from './LogoutSuccessContentSelector';

export function useLogoutSuccess(): AbstractContentState<LogoutSuccess> {
    return useCmsContent(fetchLogoutSuccess, LogoutSuccessContentSelector);
}
